import React, { useEffect } from "react";

/**
 * NpfChatbot — NoPaperForms chatbot, lazy-loaded on first user interaction.
 *
 * Renders the hidden `npf_chatbots` placeholder the vendor script hooks onto,
 * then injects the bot script only after the first scroll / touch / mouse / key
 * interaction (so it never blocks initial page load). Loads once per session.
 *
 * Mounted only on the home page (src/pages/home/index.js).
 */

const CHATBOT_SRC =
  "https://chatbot.in4.nopaperforms.com/en-gb/backend/bots/niaachtbtscpt.js/490309940d9b4cfab2cb948bbad25854/e921713035884d8db3c18b4cb7f494e7";

const INTERACTION_EVENTS = ["scroll", "touchstart", "mousemove", "keydown", "click"];

const NpfChatbot = () => {
  useEffect(() => {
    if (window._npfChatbotLoaded) return;

    const loadChatbot = () => {
      if (window._npfChatbotLoaded) return;
      window._npfChatbotLoaded = true;
      removeListeners();

      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = CHATBOT_SRC;
      document.body.appendChild(s);
    };

    const removeListeners = () => {
      INTERACTION_EVENTS.forEach((evt) =>
        window.removeEventListener(evt, loadChatbot)
      );
    };

    INTERACTION_EVENTS.forEach((evt) =>
      window.addEventListener(evt, loadChatbot, { passive: true })
    );

    return removeListeners;
  }, []);

  return (
    <div
      className="npf_chatbots"
      data-w="e921713035884d8db3c18b4cb7f494e7"
      style={{ display: "none" }}
    ></div>
  );
};

export default NpfChatbot;
